import { useLocation, useNavigate } from "react-router-dom";
import * as Yup from 'yup';

import Api from "../../Api";
import { LoginForm } from "../../component";

const Login = () => {
  const api = Api();
  const location = useLocation();
  const navigate = useNavigate();

  const LoginSchema = Yup.object().shape({
    username: Yup.string()
      .test('is-valid-username', 'Invalid email or mobile number', value => {
        return (
          Yup.string().email().isValidSync(value) ||
          /^[0]?[6789]\d{9}$/.test(value)
        );
      })
      .required('Username is required'),
    password: Yup.string().required('Password is required'),
  });

  const onLogin = (username: string, password: string) => {
    api.user.login(username, password)
      .then(() => {
        navigate(location.state?.from?.pathname || '/');
      })
  };

  return (<>
    <LoginForm
      onLogin={onLogin}
      LoginValidationSchema={LoginSchema}
    />
  </>)
};

export default Login;
